var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcMessageChat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "message-chat-square"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M13.8495 36.2274C12.9916 37.096 12.5626 37.5304 12.1939 37.561C11.874 37.5876 11.5608 37.459 11.3519 37.2153C11.1111 36.9344 11.1111 36.324 11.1111 35.1031V31.9832C11.1111 30.8879 10.2141 30.0954 9.13041 29.9366V29.9366C6.50749 29.5524 4.44755 27.4925 4.06335 24.8696C4 24.4371 4 23.921 4 22.8889V13.6C4 10.2397 4 8.55953 4.65396 7.27606C5.2292 6.14708 6.14708 5.2292 7.27606 4.65396C8.55953 4 10.2397 4 13.6 4H28.4C31.7603 4 33.4405 4 34.7239 4.65396C35.8529 5.2292 36.7708 6.14708 37.346 7.27606C38 8.55953 38 10.2397 38 13.6",
    stroke: "#000A66",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_2",
    d: "M20.0001 30.0001L13.8496 36.2275M38.0001 13.6001V22.0001M38.0001 44.0001L33.6473 40.9739C33.0354 40.5485 32.7295 40.3358 32.3965 40.185C32.101 40.0511 31.7903 39.9537 31.4713 39.8949C31.1118 39.8287 30.7392 39.8287 29.994 39.8287H26.4001C24.1599 39.8287 23.0398 39.8287 22.1842 39.3927C21.4315 39.0092 20.8196 38.3973 20.4361 37.6446C20.0001 36.789 20.0001 35.6689 20.0001 33.4287V28.4001C20.0001 26.1599 20.0001 25.0398 20.4361 24.1841C20.8196 23.4315 21.4315 22.8196 22.1842 22.4361C23.0398 22.0001 24.1599 22.0001 26.4001 22.0001H37.6001C39.8403 22.0001 40.9604 22.0001 41.8161 22.4361C42.5687 22.8196 43.1807 23.4315 43.5641 24.1841C44.0001 25.0398 44.0001 26.1599 44.0001 28.4001V33.8287C44.0001 35.6924 44.0001 36.6243 43.6956 37.3594C43.2897 38.3395 42.511 39.1182 41.5309 39.5242C40.7958 39.8287 39.8639 39.8287 38.0001 39.8287V44.0001Z",
    stroke: "#000A66",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 10",
    opacity: 0.3,
    cx: 27.4185,
    cy: 30.9893,
    r: 1.5,
    fill: "#000A66"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 11",
    opacity: 0.3,
    cx: 32.4185,
    cy: 30.9893,
    r: 1.5,
    fill: "#000A66"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 12",
    opacity: 0.3,
    cx: 37.4185,
    cy: 30.9893,
    r: 1.5,
    fill: "#000A66"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMessageChat);
export default __webpack_public_path__ + "static/media/ic-message-chat.eedf30371f740db37c82bbe26c40b014.svg";
export { ForwardRef as ReactComponent };